import { filter, map, take } from 'rxjs/operators';
import { Wso2IntegrationService } from '@mapa/core';
import * as i0 from "@angular/core";
import * as i1 from "@mapa/core";
/**
 * AuthGuard que sempre retorna "true", ou seja, sempre permite que o usuário acesse a página requisitada,
 * mas só depois de carregar e preparar o usuário logado para evitar que a página faça requisições antes disso.
 */
export class EnsureUserLoadedGuard {
    constructor(wso2IntegrationService) {
        this.wso2IntegrationService = wso2IntegrationService;
    }
    canActivateChild(childRoute, state) {
        return this.wso2IntegrationService.usuario.pipe(filter(value => !!value), take(1), map(() => {
            return true;
        }));
    }
}
EnsureUserLoadedGuard.ngInjectableDef = i0.defineInjectable({ factory: function EnsureUserLoadedGuard_Factory() { return new EnsureUserLoadedGuard(i0.inject(i1.Wso2IntegrationService)); }, token: EnsureUserLoadedGuard, providedIn: "root" });
